import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, styled } from '@mui/material';
import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';

const bubbleBG = palette.neutral[50];
const text = palette.blue[500];

export const StyledIconButton = styled(IconButton)`
  position: relative;
`;

export const CopyIcon = styled(ContentCopyIcon)`
  color: white;
  margin-top: -8px;
  ${theme.breakpoints.up('sm')} {
    font-size: 30px;
  }
`;

export const ToolTip = styled('span')`
  position: absolute;
  top: -50px;
  border-radius: ${theme.radius.sm};
  color: ${text};
  font-family: Din;
  font-size: 16px;
  width: 90px;
  padding: 0.5rem 1rem;
  display: inline-block;
  background: ${bubbleBG};
  z-index: 1;

  &:after {
    content: '';
    border: 8px solid ${bubbleBG};
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-color: ${bubbleBG} transparent transparent transparent;
    z-index: 1;
  }
`;
